import * as React from "react";
const SvgIconStop = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 11, height: 11, viewBox: "0 0 11 11", ...props }, /* @__PURE__ */ React.createElement("rect", { id: "Rectangle_179", "data-name": "Rectangle 179", width: 11, height: 11, fill: "currentColor" }));
export default SvgIconStop;
